module.exports = __webpack_public_path__ + "res/Roboto-Light-webfontd41d.eot?23d8d5c71fabe59ed3eb33c1cf1f687b";


//////////////////
// WEBPACK FOOTER
// ./assets/fonts/roboto/Roboto-Light-webfontd41d.eot
// module id = 62
// module chunks = 0